import { useContext, memo } from "react";

import { useAuth0 } from "@auth0/auth0-react";

import { getQuery } from "api/UdasWrapper";
import { PermissionsContext } from "context/AppProvider/PermissionsContext";
import { PERMISSIONS } from "constants/portal";

export async function checkUserPermissions(stripeId, userId, permissionsToCheck) {
  let data = JSON.stringify({
    query: `query Query($userId: String!, $tenantId: String!, $permissionsToCheck: [String!]!) {
      checkUserPermission(user_id: $userId, tenant_id: $tenantId, permissions_to_check: $permissionsToCheck) {
        resultObject
      }
    }`,
    variables: {
      userId: userId,
      tenantId: stripeId,
      permissionsToCheck: permissionsToCheck,
    },
  });
  try {
    const response = await getQuery(data);
    return response?.checkUserPermission?.resultObject;
  } catch (error) {
    console.log(error);
  }
}

const ProtectedButton = ({ permissionName, children, isOwner }) => {
  const { isLoading } = useAuth0();
  const { userPermissions } = useContext(PermissionsContext);

  const getPermission = (name) => {
    return userPermissions?.find((permission) => permission.name === name)?.value;
  };

  const hasAccess = () => {
    if (isOwner) return true;

    switch (permissionName) {
      case "manageUserMembership":
        return getPermission(PERMISSIONS.INVITE_USERS) || getPermission(PERMISSIONS.EDIT_USERS) || getPermission(PERMISSIONS.REMOVE_USERS);
      case "createEditDeleteShareConnetors":
        return (
          getPermission(PERMISSIONS.EDIT_CONNECTORS) ||
          getPermission(PERMISSIONS.DELETE_CONNECTORS) ||
          getPermission(PERMISSIONS.SHARE_CONNECTORS)
        );
      case "editAndRemoveUsers":
        return getPermission(PERMISSIONS.EDIT_USERS) || getPermission(PERMISSIONS.REMOVE_USERS);
      case "removeAndEditRoles":
        if (
          getPermission(PERMISSIONS.REMOVE_ROLES) === false &&
          getPermission(PERMISSIONS.EDIT_ROLES) === false
        ) {
          return false;
        }
        return true;
      default:
        return getPermission(permissionName);
    }
  };

  if (isLoading) {
    return;
  }

  return hasAccess() ? children : null;
};

export default memo(ProtectedButton);
